/**
 * @packageDocumentation
 * @module      EmcSubsystemsVersionData.ts
 * @description Contains Emc sub-systems version related data
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
export default class EmcSubsystemsVersionData {
    constructor() {
        this.drive1_version = "";
        this.drive2_version = "";
        this.drive3_version = "";
        this.drive4_version = "";
        this.p1p2_version = "";
        this.p34p5_version = "";
        this.frame_version = "";
        this.psrc_version = "";
        this.psic_version = "";
        this.psui_version = "";
        this.pssc_version = "";
        this.csrc_version = "";
        this.csic_version = "";
        this.csui_version = "";
        this.cssc_version = "";
        this.pim_version = "";
        this.emc_software_version = "";
        this.emc_ui_tool_version = "";
        this.system_tester_ui_tool_version = "";
    }
    static fromJSON(json) {
        if (json) {
            let emcSubsystemsVersionData = new EmcSubsystemsVersionData();
            if (json.DModule1 && json.DModule1.ModuleVersion) {
                emcSubsystemsVersionData.drive1_version = json.DModule1.ModuleVersion;
            }
            if (json.DModule2 && json.DModule2.ModuleVersion) {
                emcSubsystemsVersionData.drive2_version = json.DModule2.ModuleVersion;
            }
            if (json.DModule3 && json.DModule3.ModuleVersion) {
                emcSubsystemsVersionData.drive3_version = json.DModule3.ModuleVersion;
            }
            if (json.DModule4 && json.DModule4.ModuleVersion) {
                emcSubsystemsVersionData.drive4_version = json.DModule4.ModuleVersion;
            }
            if (json.ArmModuleP1p2 && json.ArmModuleP1p2.ModuleVersion) {
                emcSubsystemsVersionData.p1p2_version = json.ArmModuleP1p2.ModuleVersion;
            }
            if (json.ArmModuleP34p5 && json.ArmModuleP34p5.ModuleVersion) {
                emcSubsystemsVersionData.p34p5_version = json.ArmModuleP34p5.ModuleVersion;
            }
            if (json.Frame && json.Frame.ModuleVersion) {
                emcSubsystemsVersionData.frame_version = json.Frame.ModuleVersion;
            }
            if (json.GUI_OUT) {
                if (json.GUI_OUT.BSUModelVerNum) {
                    emcSubsystemsVersionData.emc_software_version = json.GUI_OUT.BSUModelVerNum;
                }
            }
            if (json.Versions) {
                if (json.IsControlSide === true) {
                    if (json.Versions.RC) {
                        emcSubsystemsVersionData.csrc_version = json.Versions.RC;
                    }
                    if (json.Versions.IC) {
                        emcSubsystemsVersionData.csic_version = json.Versions.IC;
                    }
                    if (json.Versions.UI) {
                        emcSubsystemsVersionData.csui_version = json.Versions.UI;
                    }
                    if (json.Versions.SC) {
                        emcSubsystemsVersionData.cssc_version = json.Versions.SC;
                    }
                    if (json.Versions.PIM) {
                        emcSubsystemsVersionData.pim_version = json.Versions.PIM;
                    }
                }
                else {
                    if (json.Versions.RC) {
                        emcSubsystemsVersionData.psrc_version = json.Versions.RC;
                    }
                    if (json.Versions.IC) {
                        emcSubsystemsVersionData.psic_version = json.Versions.IC;
                    }
                    if (json.Versions.UI) {
                        emcSubsystemsVersionData.psui_version = json.Versions.UI;
                    }
                    if (json.Versions.SC) {
                        emcSubsystemsVersionData.pssc_version = json.Versions.SC;
                    }
                }
            }
            emcSubsystemsVersionData.emc_ui_tool_version = appConfig.systemsManagerVersion;
            emcSubsystemsVersionData.system_tester_ui_tool_version = appConfig.systemTesterVersion;
            return emcSubsystemsVersionData;
        }
        return null;
    }
}
//# sourceMappingURL=EmcSubsystemsVersionData.js.map